import { forwardRef } from 'react'
import type { InputHTMLAttributes } from 'react'
import { cn } from '@/lib/utils'

export interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  label?: string
  error?: string
}

const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ className, label, error, id, ...props }, ref) => {
    const inputId = id ?? label?.toLowerCase().replace(/\s/g, '-')
    return (
      <div className="space-y-1.5">
        {label && (
          <label
            htmlFor={inputId}
            className="block text-sm font-medium text-[var(--color-text-secondary)]"
          >
            {label}
          </label>
        )}
        <input
          id={inputId}
          className={cn(
            'flex h-11 w-full rounded-[var(--radius-md)] border border-[var(--color-border-default)] bg-[var(--color-bg-elevated)] px-3 py-2 text-sm text-[var(--color-text-primary)] placeholder:text-[var(--color-text-muted)] transition-colors duration-200 ease-[var(--ease-smooth)] focus:outline-none focus:border-[var(--color-accent-amber)]/50 focus:ring-1 focus:ring-[var(--color-accent-amber)]/30 disabled:cursor-not-allowed disabled:opacity-50 sm:h-10',
            error && 'border-[var(--color-accent-red)] focus:border-[var(--color-accent-red)] focus:ring-[var(--color-accent-red)]/30',
            className,
          )}
          ref={ref}
          {...props}
        />
        {error && (
          <p className="text-xs text-[var(--color-accent-red)]">{error}</p>
        )}
      </div>
    )
  },
)
Input.displayName = 'Input'

export { Input }
